import { type ReactNode, useState } from "react";
import { FormattedMessage } from "react-intl";

import WorkflowModal from "common/modals/workflow_modal";
import Button from "common/core/button";
import AlertMessage from "common/core/alert_message";

import { scrollToSection } from "../util";
import { TITLE_UNDERWRITER_FIELD_ID } from "../../sections/transaction_details";

export const ON_SEND_MODAL_ERRORS = ["transaction_not_serviceable_by_any_notary"];

export function useOnSendErrorHandler() {
  const [submitErrorModal, setSubmitErrorModal] = useState<ReactNode>(null);

  function clearErrorModal() {
    setSubmitErrorModal(null);
  }

  function onAcknowledgeError(elementId: string) {
    scrollToSection(elementId);
    setSubmitErrorModal(null);
  }

  const onSendErrorHandler = (error: string): void => {
    if (error === "transaction_not_serviceable_by_any_notary") {
      setSubmitErrorModal(
        <WorkflowModal
          title={
            <FormattedMessage
              id="584eafb6-d532-49e5-9e97-ec0a8b48d3f4"
              defaultMessage="Select a different title underwriter"
            />
          }
          closeBehavior={{ tag: "with-button", onClose: clearErrorModal }}
          buttons={[
            <Button
              key="title-underwriter"
              variant="primary"
              buttonColor="action"
              onClick={() => onAcknowledgeError(TITLE_UNDERWRITER_FIELD_ID)}
            >
              <FormattedMessage
                id="da8e45a7-e0c4-4645-811e-d8ff354d9cb6"
                defaultMessage="Continue"
              />
            </Button>,
          ]}
        >
          <AlertMessage kind="danger">
            <FormattedMessage
              id="1830cd91-9890-4a97-aabc-9b9cbad78ac0"
              defaultMessage="There is no notary that can meet the transaction requirements set by the title underwriter. Please select a different title underwriter."
            />
          </AlertMessage>
        </WorkflowModal>,
      );
    }
  };

  return {
    onSendErrorHandler,
    onsendErrorModal: submitErrorModal,
  };
}
